export const isInternalEmail = (email?: string) => /@betterpool\.com$/.test(email ?? '');

export const isTesterEmail = (email?: string) =>
  /^qe_tester[a-z0-9-_+]*@betterpool\.com$/.test(email ?? '');
